<template>
  <Html>
    <Body id="app">
      <div class="min-h-dvh flex flex-col">
        <AppHeader />
        <main class="pt-6 pb-24 container flex-1 flex flex-col justify-center items-center">
          <div class="text-center">
            <h2 class="text-primary-500 mb-3">
              {{ title }}
            </h2>

            <div
              class="mb-8"
              v-html="props.error.statusCode === 404 ? 'Zkontrolujte zdali je zadaná adresa správně' : props.error.message"
            />
          </div>

          <pre
            v-if="hasStack"
            class="stack-wrapper"
            v-html="props.error.stack"
          />

          <a
            v-else
            href="/"
          >
            <el-button
              type="primary"
            >
              Přejít na hlavní stranu
            </el-button>
          </a>
        </main>
      </div>
    </Body>
  </Html>
</template>

<script setup>
const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
});

// Computed
const hasStack = computed(() => props.error.stack && import.meta.dev);
const title = computed(() => props.error.statusCode === 404 ? 'Stránka nebyla nalezena' : 'Došlo k neočekávané chybě');

useSeoMeta({
  title: `${title.value} | ${useRuntimeConfig()?.public?.title || ''}`,
});
</script>

<style scoped>
.stack-wrapper {
  background: rgb(0 0 0 / 0.05);
  border-radius: 0.25rem;
  padding: 1rem;
  width: 100%;
  overflow-y: auto;
  height: auto;
  font-size: 0.75rem;
  line-height: 1.5;
  color: #444d56;
}
</style>
